import { HeaderText } from "@/components/ui";
import { useParams } from "@tanstack/react-router";
import { useGetPatient } from "../Patient/network/usePatient";
import { isUniversalClinicPatient } from "../Patient/utils";
import { UniversalClinicChat } from "./UniversalClinicChat/UniversalClinicChat";
import { ChatMessageList } from "./components/ChatMessageList";
import { Collaborators } from "./components/Collaborators/Collaborators";

export const Chat = () => {
  const { patientId } = useParams({ strict: false });
  const { data: patient } = useGetPatient(patientId as string);
  const isAmazonPatient = patient?.amazonId;
  const patientIsUniversalClinic = isUniversalClinicPatient(patient);

  return (
    <div className="w-full min-h-0 flex flex-col border rounded-md min-w-[33%] max-w-[50%]">
      <div className="flex items-center justify-between p-2">
        <HeaderText textColor="tertiary" size="sm">
          Chat
        </HeaderText>
        <div className="flex gap-1">
          {!isAmazonPatient && <Collaborators />}
        </div>
      </div>
      <div className="flex-1 overflow-hidden">
        {patientIsUniversalClinic ? (
          <UniversalClinicChat />
        ) : (
          <ChatMessageList />
        )}
      </div>
    </div>
  );
};
